module.exports = __webpack_public_path__ + "static/media/house.906ced43.svg";